export default {
  base: {
    search: "Search",
    reset: "Reset",
    operation: "Operation",
    edit: "Edit",
    detail: "Detail",
    submit: "Submit",
    back: "Back",
    sure: "are you sure",
    cancle: "Cancle",
    choice: "Please choice",
    success: "Success",
    del: "Delete?",
    delCon: "Confirm deletion of the record",
    delChannel: "Confirm deletion of the channel",
    updatedAt: "Operation",
    beginDate: "BeginDate",
    endDate: "EndDate",
    save: "Save",
    next: "Next",
    status: "Status",
    basicInFo: "Basic info",
    createInFo: "Create info",
    createTime: "Create time",
    createUser: "Create user",
    endTime: "End time",
    checkTime: "核销时间",
    ticketDetail: "Ticket detail",
    exportExcel: "Export Excel",
    qrCode: "QRcode",
    seeQrCode: "see QRcode",
    seeShapeCode: "see shape code",
    shapeCode: "Shape code",
    move: "Delete",
    basic: "Basic info",
    enter: "Please enter",
    name: "Name",
    time: "time",
    week: "week",
    ExportValidDetails: "Export valid details",
    ExportDelayDetails: "Export delay details",
    ExportscrapDetails: "Export scrap details",
    import: "import",
    litmitImg: "limit imgage",
    upload: "upload",
    pass: "pass",
    refuse: "refuse",
    refusereason: "refuse reason",
    yes: "yes",
    no: "no",
    startUsing: "start using",
    forbidden: "forbidden",
    export: "export report",
    report: "report",
    notice: "Notice",
    confirmverification: "confirm verification",
    exportXml: "export",
    delete: "delete",
    createOrder: "下单",
    ticketKindDetail: "票种详情",
    count: "数量",
    print: "打印",
    download: "下载",
  },
  search: {
    name: "Name",
    status: "Status",
    code: "Code",
    venue: "venue",
    performance: "performance",
    date: "date",
    enterName: "Please enter venue name",
    enterCode: "Please enter the code",
    enterStatus: "Please select status",
    enterVenue: "Please enter venue",
    enterDate: "Please select date",
    userId: "user ID",
    enterUserId: "please enter user id",
    tel: "telphone",
    enterTel: "please enter phone",
    nickName: "nick name",
    enternickName: "please enter nick name",
    orderID: "order ID",
    enterOrderId: "please enter order ID",
    payStatus: "pay status",
    enterPayStatus: "please select pay status",
    orderStatus: "order status",
    enterOrderStatus: "please select order status",
    maNo: "maNo",
    externalOrderId: "external order ID",
    registeredTime: "registered time",
    createOrderTime: "Order time",
    statisticalTime: "statistical time",
  },
  tips: {
    totalSoldTicketCount: "Total number of tickets sold through all channels within the time frame",
    totalSoldSeatCount: "Total seats sold through all channels within the time frame",
    totalTransCount: "Total number of orders sold through all channels within the time frame",
    totalSales: "Total amount sold for all channels within the time frame",
    totalAllotment: "The number of channel stocks available for all channels in the time frame",
    totalSeatSoldPercent: "Total seats sold / The total votes",
    transCount: "Transaction orders for current channels within the time frame",
    transPercent: "Transaction order / Total transaction orders within the time frame",
    sales: "Amount sold in current channel within time frame",
    allotment: "Channel inventory of the current channel for valid sessions within the time frame",
    soldTicketCount: "The number of available tickets for the current channel within the time frame",
    soldSeatCount: "The number of seats sold in the current channel within the time frame",
  },

  payTypeTips: {
    totalSales: "The total amount sold for all payment methods within the time frame",
    sales: "The amount sold within the time frame of the current mode of payment",
  },

  salesTips: {
    totalTicketCount: "The number of tickets sold through all channels within the time frame",
    totalIssue: "The number of seats sold through all channels within the time frame",
    totalIssuePercent: "Total seats sold / The total votes",
    totalAvail: "Total number of seats available / The total votes",
    totalAvailPercent: "Total number of seats available / The total votes",
    totalSales: "Amount sold for all channels within the time frame",
  },

  ticketKindTips: {
    totalAllotment: "The number of tickets in stock for the total number of tickets available within the time frame",
    totalTicketSold: "The total number of tickets sold within the time frame",
    totalSeatSold: "The number of seats sold for all types of tickets within the time frame",
    totalTicketSales: "The amount of all tickets sold within the time frame",
    allotment: "The stock of the current ticket type for the time period",
    ticketSold: "The number of tickets sold within the time frame",
    seatSold: "The number of seats sold for the current type of ticket within the time frame",
    ticketSales: "The amount of current tickets sold within the time frame",
  },

  // 场馆
  Venues: {
    cg: "Venues Add",
    status: "Status",
    code: "Code",
    address: "Address",
    baidu: "Baidu Location",
    google: "Google Loation",
    desc: "Describe",
    longitude: "Long",
    latitude: "Lat",
    Id: "venues id",
    contact: "Contact",
    detailAd: "Detail Address",
    venuesnew: "VenuesAdd",
    venuesedit: "VenuesEdit",
    name: "Name",

    del: "Confirm the deletion",
    delCon: "Confirm to delete the record",

    // 场馆提示语
    // input 内文字
    vName: "Please enter venue name",
    vCode: "Please enter venue code",
    vTel: "Please enter your contact information",
    vLocation: "Please select venue address",
    vDeatilLocation: "Please enter the detailed address",
    vBaiDuLongitude: "Longitude",
    vBaiDuLatitude: "Latitude",
    vGoogleLongitude: "Longitude",
    vGoogleLatitude: "Latitude",
    vDescription: "Description",
    vSel: "Please select status",
  },

  // 演出
  // rformancedit: 'PerformancEdit',
  Performance: {
    setting: "setting",
    performance: "performance",
    lperformance: "please select performance",
    rformancediticketKind: "Performance TicketKind",
    create: "Creat",
    edit: "Edit",
    detail: "Detail",
    showtime: "Showtime",

    // table
    // add: 'Performance Add',
    sequenceNumber: "sequenceNumber",
    performanceId: "performance id",
    performanceCode: "performance code",
    venueName: "venue name",
    performanceName: "performance name",
    verticalImageUrl: "vertical poster",
    performanceBeginTime: "begin time",
    performanceEndTime: "end time",
    performanceStatus: "status",
    // end
    // tab change
    basic: "Basic Info",
    ticketInfo: "Ticket Info",
    vieingInfo: "Viewing Info",
    video: "Video",
    lightspot: "LightSpot",
    channel: "Channel",
    lchannel: "please select channel",
    // end
    lName: "performance name",
    pName: "Please enter name",
    lCode: "performance code",
    pCode: "Please enter code",
    lSequenceNumber: "sequenceNumber",
    pSequenceNumber: "Please enter sequenceNumber",
    lVenuesId: "VenuesId",
    pVenuesId: "Please select Venues id",
    lConfigId: "config id",
    pConfigId: "Please select config id",
    lPrice: "price",
    pPrice: "Please enter price",
    lTicketTotal: "total ticket count",
    pTicketTotal: "Please enter total ticketCount",
    lShareTicket: "share ticket count",
    pShareTicket: "Please enter share ticket Count",
    lCrossPoster: "cross poster",
    pCrossPoster: "Please upload cross poster",
    lVerticalPoster: "vertical poster",
    lPerticalPoster: "pertical poster",
    pVerticalPoster: "Please upload vertical poster",
    lTime: "show Time",
    time: "Please select show time",
    status: "Please select status",
    description: "Description",
    lLockTicketTotal: "total lock ticket count",
    lLockShareTicket: "share lock ticket count",
    // video 内容
    addVideo: "creat video",
    videoId: "video id",
    videoType: "video type",
    videoUrl: "video url",
    videoImg: "video image",
    videoStatus: "video status",
    img: "image",
    uploadVideo: "upload video",
    posterImg: "poster image",
    pPoster: "upload poster",
    clientName: "video name",

    // lightSpot
    addLightSpot: "creat lightspot",
    lightSpotId: "lightspot id",
    lightSpotTitle: "lightspot title",
    llightSpotTitle: "please enter lightspot title ",
    lightSpotDes: "description",
    lightSpotStatus: "lightspot status",
    itemlightSpot: "item lightSpot",

    // channel
    associatedChannel: "associated channel",
    channelId: "channel id",
    channelName: "channel name",
    usedInventory: "used inventory",
    lockInventory: "lock inventory",
    ticketKind: "ticket type",
    lSticketKind: "please select ticket type",

    // 票种
    addTicketKind: "add a ticket",
    relatedTicket: "related ticket",
    ticketKindId: "ticket type id",
    ticketKindName: "ticket type name",
    lticketKind: "please enter ticket name",
    ticketPrice: "ticket price(MOP)",
    lticketPrice: "please enter ticket price",
    maximumSingleTicket: "Maximum single purchase (zhang)",
    lmaximumSingleTicket: "please enter Maximum single purchase",
    limitTotal: "limit total inventory",
    availableSeats: "available seats (per seat)",
    lavailableSeats: "please enter available seats (per seat)",
    startWeek: "start week",
    lstartWeek: "please select start week",
    endWeek: "end week",
    lendWeek: "please select end week",
    nolimit: "no limit",
    limit: "limit",
    usedTicketKindInventory: "used inventory",
    lockTicketKindInventory: "lock inventory",

    // recommend
    addRecommend: "add recommend",
    recommend: "recommend",
    recommendId: "recommend ID",
    ticket: "Ticket Number",
    showTimeId: "showtime id",

    redundantTicketCount: "redundant ticket count",
    performanceTime: "performance time",
    parentChannelSetting: "parent channel setting",
    useShareCount: "use share count",
    parentChannelId: "parent channelId",
    totalCount: "total count",
    parentShareCount: "parent share count",
    channelSettlementPrice: "channel settlement price(RMB)",

    batchshowTime: "batch showTime",
    batchgenerated: "batch generated",
    settingShow: "setting show",
    cancelShow: "cancel show",

    exportXml: "export xml",
    exportTime: "export time",
  },

  // 渠道
  Channel: {
    channelName: "channel name",
    lchannelName: "please enter channel name",
    channelStatus: "channel status",
    lchannelStatus: "please select channel status",
    createChannel: "add channel",
    total: "channel count",
    code: "channel code",
    lcode: "please enter channel code",
    secret: "channel secret",
    lsecret: "please enter channel secret",
    recharge: "recharge",
    companyInfo: "company info",
    financialInfo: "financial info",
    contacts: "contacts",
    lcontacts: "please enter contacts",
    rechargeList: "recharge list",
    type: "channel docking type",
    ltype: "please select Channel docking type",
    company: "company",
    lcompany: "please enter company",
    dutyParagraph: "duty paragraph",
    ldutyParagraph: "please enter duty paragraph",
    location: "location",
    llocation: "please enter location",
    contactsTel: "company contacts",
    lcontactsTel: "please enter company contacts",
    serviceTel: "service Tel",
    lserviceTel: "please enter serviceTel",
    bankName: "bank name",
    lbankName: "please enter bank name",
    accountNumber: "account number",
    laccountNumber: "please enter account name",
    totalPrice: "total price(yuan)",
    ltotalPrice: "please enter total price",
    usedPrice: "used price(yuan)",
    lusedPrice: "please enter used price",
    channelSettlementCycle: "channel settlement cycle",
    lchannelSettlementCycle: "please select channel settlement cycle",
    channelDeposit: "channel deposit",
    lchannelDeposit: "please enter channel deposit",
    refundDeposit: "lrefund deposit",
    lrefundDeposit: "please enter lrefund deposit",
    addcontacts: "add contacts",
    ID: "ID",
    position: "position",
    lposition: "please enter position",
    tel: "telphone",
    ltel: "please enter telphone",
    email: "email",
    lemail: "please enter email",
    comment: "comment",
    lcomment: "please enter comment",
    ldesc: "please enter description",
    addRecharge: "add recharge",
    rechargeId: "recharge ID",
    rechargeVoucher: "recharge voucher",
    rechargePrice: "recharge price",
    lrechargePrice: "please enter recharge price",
    rechargePriceBefore: "before recharge price",
    rechargePriceAfter: "after recharge price",
    rechargeTime: "recharge time",
    auditStatus: "audit status",
    audit: "audit",
    check: "check",
    fillInfo: "Please fill in the financial information first",
    uploadRecharg: "upload recharg",
  },

  // 票种管理
  ticketKind: {
    addTicketKind: "add ticket type",
    ticketKindInfo: "ticket type info",
    isAllDay: "all day",
    minTicketPerTime: "单人最小购买量（套）",
    maxTicketPerTime: "单人最大购买量（套）",
    limitStock: "是否限制票种库存",
    usedTicketCount: "票种已用库存数",
    chanelSettlePrice: "渠道结算价",
    chanelSettlePrices: "渠道结算价（元）",
    currencyNote: "币种",
  },

  // 场次
  ShowTime: {
    add: "Add",
    importVerifiedDetail: "import verified detail",
    sessionValidity: "session validity",
    ticketValidity: "ticket validity",
    totalCount: "total count(piece)",
    salesCount: "sales count(piece)",
    showtimeCode: "show time code",
    lshowtimeCode: "please enter show time code",
    showTime: "show time",
    salesTime: "sales time",
    showtimeName: "show time name",
    showtimeType: "ticket check type",
    singleTicketCount: "独享库存数（张）",
    selledSharedCount: "已售共享库存数（张）",
    soldSingleTicketCount: "已售独享库存数（张）",
    relatedTicketKind: "关联票种",
    hasLimitStockTicketKind: "是否存在限制库存票种",
    limitStockTicketKind: "限制票种剩余可售",
  },

  // 用户
  User: {
    headerUrl: "header url",
    RegistrationDate: "registration date",
    gender: "gender",
    channelName: "channel",
    canCheck: "check permissions",
    blacklist: "black list",
    recover: "recover",
    cancaelpermission: "cancael permission",
    settingpermission: "setting permission",
    cardInfo: "card info",
    cardNumber: "card number",
    userInfo: "user info",
    channelId: "channel id",
  },

  // 会员权益
  UserInfo: {
    add: "add user info",
    discount: "discount(%s)",
    userinfo: "user info",
    strategyName: "strategy name",
  },

  // 订单
  Order: {
    orderPrice: "order amount",
    actualAmount: "actual amount",
    payWay: "pay type",
    orderInfo: "Order Info",
    strategyId: "strategy id",
    vName: "venue name",
    buyTicker: "buy ticketer",
    buyTickerInfo: "buyTicker info",
    ticketCount: "ticket count",
    seatCount: "seat count",
    taobaoToken: "taobao token",
    payEndTime: "pay end time",
    payTime: "pay time",
    payId: "pay id",
    changeTime: "change time",
    chargeBackInfo: "Charge back info",
    chargeBackStatus: "charge back status",
    chargeBackTime: "charge back time",
    Eticket: "E-ticket",
    ticketID: "ticketID",
    ticketCode: "ticket code",
    orderId: "order id",
    orderStatus: "order status",
    payStatus: "pay status",
    sorderId: "please enter the order id",
    suserId: "please enter the user id",
    sorderStatus: "please select order status",
    spayStatus: "please select pay status",
    electronicticket: "electronic ticket",
    refund: "refund",
    chargeBackReson: "charge back reson",
    lChargeBackReson: "please enter charge back reson",
    payID: "pay ID",
    thirdOrderId: "third order Id",
    amount: "Actual payment amount:",
    externalOrderId: "external order id",
    verification: "verification",
    type: "verification type",
    encryptCode: "encrypt code",
    code: "ticket code/order code",
    parentOrderId: "团体订单ID",
    corderId: "中台订单ID",
    returnOrder: "退单",
    contactUser: "联系人",
    contactMobile: "联系电话",
    orderCount: "张数",
  },

  // 票
  Ticket: {
    ticketconfigadd: "Config Add",
    sshowtime: "please enter the showtime id",
    sconfig: "please enter the config id",
    configName: "config name",
    configdetail: "Config Detail",
    ticketdetail: "Ticket Detail",
  },

  // 权限管理
  Auth: {
    useradd: "User Add",
    permiss: "Permissions",
    email: "account",
    manageuserId: "user id",
    realName: "name",
    user: "User",
    password: "password",
    navigationName: "navigation name",
    navigationId: "navigation id",
  },

  // 价格策略
  Discount: {
    sshowTimeId: "please select the showtime",
    scouponType: "please select the coupon type",
    couponType: "coupon type",
    discountadd: "Discount Add",
    strategyId: "strategy id",
    rangeTime: "range time",
    couponPrice: "coupon price",
    couponTicketCount: "couponTicketCount",
    perUserMaxTicket: "perUserMaxTicket",
    discountdetail: "Discount detail",
    srangeTime: "please choose the rangeTime",
    discount: "Discount",
  },

  // 推荐位
  Banner: {
    addbanner: "Banner Add",
    bannerId: "BannerId",
    location: "Location",
    linkUrl: "LinkUrl",
    llinkUrl: "Please enter a jump link",
    img: "Image",
    bannerType: "BannerType",
    lbannerType: "Please select the type",
  },

  // 兑换码
  Activation: {
    goodsId: "GoodsId",
    createTime: "CreateTime",
    goodsName: "GoodsName",
    bindTypeText: "BindType",
    count: "Count",
    user: "User",
    addCode: "ActivationCode Add",
    lgoodsName: "Please enter the exchange code name",
    bindType: "BindType",
    lbindType: "Please select the binding mode",
    ldate: "Please select date",
    date: "Date",
    validDays: "ValidDays",
    all: "All",
    edate1: "The start time must be greater than the current time",
    edate2: "Start time and end time cannot be the same time",
    time: "Valid time",
  },

  // 淘宝
  Taobao: {
    addTaobao: "Taobao Add",
    taobaoItemId: "taobao id",
    taobaoTicketKindName: "taobao ticket name",
    showtimeId: "showtime id",
    performanceName: "performance name",
    ticketKindName: "ticketKind name",
    detailtitle: "taobao detail",
    performanceId: "performance id",
    ticketKindId: "ticketKind id",
    itemType: "item type",
  },

  TicketKind: {
    ticketKindId: "票种ID",
    ticketKindName: "票种名称",
    ticketKindType: "票种类型",
    minTicketPerTime: "单人最小购买量（套）",
    maxTicketPerTime: "单人最大购买量（套）",
    limitStock: "是否限制票种库存",
    usedTicketCount: "票种已用库存数",
    chanelSettlePrice: "渠道结算价",
    currencyNote: "币种",
  },

  // 报表
  Report: {
    daily: "Daily",
    week: "Week",
    month: "Month",
    year: "Year",
    time: "Time",
    startmonth: "start month",
    endmonth: "end month",
    startday: "start day",
    endday: "end day",
    totalSoldTicketCount: "TotalSoldTicketCount",
    totalSoldSeatCount: "TotalSoldSeatCount",
    totalTransCount: "TotalTransCount",
    totalSales: "TotalSales",
    totalAllotment: "TotalAllotment",
    totalSeatSoldPercent: "TotalSeatSoldPercent",
    soldTicketCount: "SoldTicketCount",
    soldSeatCount: "SoldSeatCount",
    soldSeatPercent: "SoldSeatPercent",
    transCount: "TransCount",
    transPercent: "TransPercent",
    sales: "Sales",
    allotment: "Allotment",
    settleTime: "SettleTime",
    totalIssue: "TotalIssue",
    totalTicketCount: "TotalTicketCount",
    totalIssuePercent: "TotalIssuePercent",
    totalAvail: "TotalAvail",
    totalAvailPercent: "TotalAvailPercent",
    totalTicketSold: "TotalTicketSold",
    totalSeatSold: "TotalSeatSold",
    TotalSeatSoldPercent: "TotalSeatSoldPercent",
    totalTicketSales: "TotalTicketSales",
    ticketSales: "TicketSales",
    seatSoldPercent: "SeatSoldPercent",
    seatSold: "SeatSold",
    ticketSold: "TicketSold",
    selectYear: "select year",
    selectMonth: "select month",
    selectWeek: "select week",
    slectDay: "select date",
    export1: "export Past day Sales",
    export2: "export Daily Sales",
    export3: "export Daily Allotment",
  },

  // 面包屑
  shboardenues: "Venues",
  rformance: "Performance",
  annelanagement: "Channel",
  cketind: "TicketKind",
  owtimeanagement: "Showtime",
  eranagement: "User",
  deranagement: "Order",
  cket: "Ticket",
  cketanagement: "Ticketmanagement",
  cketonfig: "Ticketconfig",
  ttletatistic: "Settlestatistic",
  th: "Auth",
  thser: "AuthUser",
  thist: "Authlist",
  nagementiscount: "Discount",
  nner: "Banner",
  tivationode: "ActivationCode",
  obao: "Taobao",
  shboardenuesdit: "dashboardVenuesEdit",
  rformanceanagement: "PerformanceManagement",
  rformanceetail: "PerformanceDetail",
  rformancedd: "PerformanceAdd",
  rformanceecommend: "PerformanceRecommend",
  rformancedit: "PerformanceEdit",
  annelanagementdit: "ChannelManagementEdit",
  annelanagementdd: "ChannelManagementAdd",
  cketinddd: "TicketKindAdd",
  cketinddit: "TicketKindedit",
  cketindetail: "TicketKindetail",
  owtimeanagementdit: "ShowtimeManagementEdit",
  owtimeanagementetail: "ShowtimeManagementDetail",
  eranagementard: "UserManagementCard",
  eranagementetail: "UserManagementDetail",
  deranagementetail: "OrderManagementDetail",
  deranagementticket: "OrderManagementEticket",
  deranagementticketetail: "OrderManagementEticketDetail",
  cketetail: "TicketDetail",
  cketonfigdit: "TicketConfigEdit",
  cketonfigetail: "TicketConfigDetail",
  nagementiscountetail: "ManagementDiscountDetail",
  nnerdit: "BannerEdit",
  tivationodeetail: "ActivationCodeDetail",
  obaoetail: "TaobaoDetail",
  port: "Report",
  porthannel: "ReportChannel",
  porticketkind: "ReportTicketkind",
  portaytype: "ReportPaytype",
  portales: "ReportSales",
  home: "Home",
  tivationodedit: "ActivationCodeEdit",
  performanceedit: "performanceEdit",
  performancenew: "performanceNew",
  rformancediticketKind: "performancediticketKind",
  owtimeanagementditicketKind: "showtimeanagementEditicketKind",
  owtimeanagementetailicketKind: "DetailitcketKind",

  showtimenew: "ShowtimeAdd",
  showtimeedit: "ShowtimeEdit",
  annelontractdd: "ChannelContractAdd",
  erinfoetail: "UserInfoDetail",
  erinfo: "UserStrategy",
  porthowtime: "Report Showtime",
  owtimeicketKindDetail: "场次票种列表",
  derreateStepOne: "下单",
  derreateStepTwo: "下单",
  derreateStepThree: "下单",
  der: "订单",
  deretailist: "零售订单",
  derroupist: "团体订单",
  derrderEticketList: "零售电子票列表",
  derrderEticketDetail: "电子票详情",
  rformanceist: "演出列表",
};
